__turbopack_context__.v({
  "className": "caveat_afc87c03-module__kLUWKW__className",
});
